import React, { createContext, useState } from "react";
import Notification from "../../components/common/Notification";
import LoyaltyProgramService from "../../services/pms_services/LoyaltyProgramService";

export const PMSLoyaltyProgramContext = createContext("PMSLoyaltyProgramContext");

const PMSLoyaltyProgramContextProvider = ({ children }) => {

    const [loyaltyProgram, setLoyaltyProgram] = useState(null);
    const [loyaltyProgramLoading, setLoyaltyProgramLoading] = useState(false);
    const [loyaltyProgramSaveLoading, setLoyaltyProgramSaveLoading] = useState(false);

    const getLoyaltyProgramByPharmacyId = async (pharmacyId) => {
        setLoyaltyProgramLoading(true);
        try {
            const res = await LoyaltyProgramService.getLoyaltyProgramByPharmacyId(pharmacyId);
            setLoyaltyProgram(res.data);
            setLoyaltyProgramLoading(false);
            return true;
        } catch (error) {
            setLoyaltyProgramLoading(false);
            let _error = "Something went wrong.";
            if (error.message === "Network Error") {
                _error = error.message;
            }
            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    const createUpdateLoyaltyProgram = async (pharmacyId, data) => {
        setLoyaltyProgramSaveLoading(true);
        try {
            const res = await LoyaltyProgramService.createUpdateLoyaltyProgram(pharmacyId, data);
            setLoyaltyProgram(res.data);
            Notification("success", "Updated", "Loyalty program has been updated successfully");
            setLoyaltyProgramSaveLoading(false);
            return true;
        } catch (error) {
            setLoyaltyProgramSaveLoading(false);
            let _error = "Something went wrong.";
            if (error.message === "Network Error") {
                _error = error.message;
            }
            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    return (
        <PMSLoyaltyProgramContext.Provider
            value={{
                loyaltyProgram,
                loyaltyProgramLoading,
                loyaltyProgramSaveLoading,
                getLoyaltyProgramByPharmacyId,
                createUpdateLoyaltyProgram,
            }}
        >
            {children}
        </PMSLoyaltyProgramContext.Provider>
    );
};

export default PMSLoyaltyProgramContextProvider;
